import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCurrentClubHasLessonsEnabled_session$key } from "./__generated__/useCurrentClubHasLessonsEnabled_session.graphql";

export const useCurrentClubHasLessonsEnabled = (
  sessionRef: useCurrentClubHasLessonsEnabled_session$key | null
) => {
  const session = useFragment(
    useCurrentClubHasLessonsEnabledFragmentString,
    sessionRef
  );
  const supportsPublic =
    session?.currentClientProfile?.member?.club?.supportsPublic ?? false;

  return !!session?.currentClientProfile?.member?.club?.facilities?.edges?.some(
    (e) =>
      supportsPublic
        ? e?.node?.publicLessonsPermissionSet?.patronAccess
        : e?.node?.privateLessonsPermissionSet?.patronAccess
  );
};

const useCurrentClubHasLessonsEnabledFragmentString = graphql`
  fragment useCurrentClubHasLessonsEnabled_session on Session {
    currentClientProfile {
      member {
        club {
          supportsPublic
          facilities {
            edges {
              node {
                publicLessonsPermissionSet {
                  patronAccess
                }
                privateLessonsPermissionSet {
                  patronAccess
                }
              }
            }
          }
        }
      }
    }
  }
`;
